export default __webpack_public_path__ + "static/media/dashboardResponsive_es.d7a88a1a.png";